export const isMobileDevice = (): boolean => {
    const userAgent = navigator.userAgent;

    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|FxiOS|Windows Phone/i;

    return mobileRegex.test(userAgent);
};
